import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Typography,
  Accordion,
  AccordionSummary as AccSummary,
  AccordionDetails,
  TextField,
  useMediaQuery,
  useTheme,
  styled,
  Box,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Controller, useForm, FormProvider } from "react-hook-form";

import {
  fileActions,
  executeSearchActions,
  addTitleLegoCurrent,
} from "../../store/actions";
import {
  ClearSession,
  coreFunctions,
  IsDevice,
  parseDate,
  ValidarSICumpleCondiciones,
} from "../../utils";
import {
  Buttons,
  GenericContainer,
  CustomLoadingOverlay,
  GenericContainerForm,
  Alert,
  AlertConfirm,
} from "../../components";
import { InputField } from "../../components/InputField";
import { executeSearchRequests } from "../../services";
import { useTranslation } from "react-i18next";
import { parse, format } from "date-fns";
import { Info } from "@mui/icons-material";

const AccordionSummary = styled(AccSummary)(({ theme }) => ({
  "&.Mui-expanded": {
    minHeight: "24px !important",
  },
  ".MuiAccordionSummary-content": {
    margin: "8px 0 !important",
    display: "flex",
    alignItems: "center",
  },
}));

export default function DynamicForm(props) {
  const location = useLocation();
  const formMethods = useForm();
  const {
    control,
    reset,
    handleSubmit,
    watch,
    setValue,
    formState,
    register,
    setError,
    clearErrors,
    getValues,
    setFocus,
    formState: { errors, submitCount },
    resetField,
  } = useForm({ mode: "onSubmit" });

  const navigate = useNavigate();

  const [properties, setProperties] = useState("");

  const [logoutOnSave, setLogoutOnSave] = useState("");
  const [title, setTitle] = useState("");
  const [folio, setFolio] = useState("");
  const [questions, setQuestions] = useState([]);
  const [loadView, setLoadView] = useState(false);
  const [loadViewCtrls, setLoadViewCtrls] = useState(false);
  const [initLoad, setInitLoad] = useState(true);
  const [saveAction, setSaveAction] = useState(false);
  const [activeFinalizeLego, setActiveFinalizeLego] = useState(false);
  const [editableForm, setEditableForm] = useState();
  const [textSubtitle, setTextSubtitle] = useState("");
  const [expandedCurrent, setExpandedCurrent] = useState("");

  const auth = useSelector((state) => state.Authentication);
  const wf = useSelector((state) => state.Workflow);
  const file = useSelector((state) => state.FileInfo);
  const fileUMet = useSelector((state) => state.File);
  const actorId = location.state.actorId;
  const [open, setOpen] = useState(false);

  const [expanded, setExpanded] = useState("");
  const [loadPostalCode, setLoadPostalCode] = useState(false);
  const [listColoniaCurrent, setListColoniaCurrent] = useState([]);
  const [initLoadCombos, setInitLoadCombos] = useState(true);
  const idiomaSeleted = process.env.REACT_APP_LANGUAGE === "pt";

  const handleClose = () => setOpen(!open);
  const dataSearchCP = useSelector((state) => state.Search);

  const { t } = useTranslation();

  const dispatch = useDispatch();
  let idUser = sessionStorage.getItem("IdUserData");

  useEffect(() => {
    dispatch(addTitleLegoCurrent(t("cargar_data_capture")));
    if (
      location.state?.activeNextLego != undefined &&
      location.state?.activeNextLego != null
    ) {
      setActiveFinalizeLego(location.state.activeNextLego);
    }
    const folioId = location.state.folioId ?? localStorage.getItem('fileId');

    setFolio(folioId);
    dispatch(fileActions.GetFileInfo(folioId));
    setLoadView(true);
  }, []);

  useEffect(() => {
    setLoadView(file.loading);
    if (file.items != undefined && initLoad && file.items.StageName == "Cuestionario dinamico") {
      setInitLoad(false);
      setProperties(file.items.Stage);
      setFolio(file.items.Id);
      setLoadView(true);
      let subTitle = file.items.Stage.Properties.find(
        (element) => element.Name == "textSubTittle"
      );

      let LogoutOnSave = file.items?.Stage?.Properties?.find(
        ({ Name }) => Name === "LogoutOnSave"
      )?.Value;
      setTextSubtitle(subTitle?.Value);
      setLogoutOnSave(LogoutOnSave);
    } else if (file.error != undefined && initLoad) {
      setLoadView(false);
    }
  }, [file, file.items]);

  useEffect(() => {
    setLoadView(fileUMet.loading);
    if (fileUMet.items != undefined && saveAction) {
      if (activeFinalizeLego) {
        navigate("/main/ConfirmComponent");
      } else if (logoutOnSave && logoutOnSave == "1") {
        //Logout y redireccion a login
        Alert(
          {
            icon: "success",
            text: t("proccess_request"),
            okbtntext: t("general_accept"),
          },
          () => {
            ClearSession();
            navigate("/auth/");
          }
        );
      } else {
        let nextStage = fileUMet.items.Stage;
        let stageName = nextStage.Name;
        let stageId = nextStage.Id;
        let stage = fileUMet.items;
        let folioId = folio;

        if (stageName == "Cuestionario dinamico") {
          setProperties(fileUMet.items.Stage);
          reset();
          setInitLoadCombos(true);
          setLoadView(true);
        }
        setFolio(folioId);
        reset();
        setInitLoadCombos(true);
        let nextComponent = coreFunctions.GetLegoNext(stageName);
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: { stageName, stageId, stage, folioId },
        });
      }
    } else if (fileUMet.error != undefined && saveAction) {
      setSaveAction(false);
      setLoadView(false);
      alert(fileUMet.error);
      setSaveAction(false);
    }
  }, [fileUMet]);

  useEffect(() => {
    if (properties != "") {
      if (properties.Description != undefined) {
        dispatch(addTitleLegoCurrent(properties.Description));
        let finVardisabled = properties.Properties?.find(
          (item) => item.Name == "Readonly"
        )?.Value;

        let disabled =
          finVardisabled == "1" || finVardisabled == 1 ? true : false;
        setEditableForm(disabled);
        let newArray = setGroupNames(properties.QuestionGroups, disabled);
        console.log('newArraynewArray', newArray)
        setQuestions(newArray);
        setInitLoadCombos(true);
        setLoadView(false);
      }
    }
  }, [properties]);

  const setGroupNames = (array, disabled = false) => {
    let newGroup = array.map((group) => {
      return {
        groupTitle: group.Name,
        folio: folio,
        description: group.Description,
        llave: group.Id,
        questions: group.Questions.map((qn) => {
          let defaultValue = "";
          // Aplicar la condición específica
          if (
            qn.QuestionType === "Radio" &&
            qn.ExecuteSearchFunction === "GetPreguntasRequeridas" &&
            (qn.Metadata === undefined || qn.Metadata === null)
          ) {
            defaultValue = idiomaSeleted ? "NÃO" : "NO";
          } else if (qn.Metadata && qn.Metadata?.Value !== undefined) {
            defaultValue = qn.Metadata.Value;
          } else {
            defaultValue = null;
          }
          return {
            ...qn,
            GroupName: group.Name,
            Value: defaultValue,
            // qn.Metadata != undefined && qn.Metadata != null
            //   ? qn.Metadata.Value
            //   : "",
            DefaultValue: null,
            Captured: null,
            Disabled: disabled, // Parametro que va indicar que es de solo lectura el campo.
            Visible:
              qn.Visible === undefined || qn.Visible === null
                ? true
                : qn.Visible,
            // Required: true
          };
        }),
      };
    });

    // ACTUALIZAR VISIBILIDAD SEGÚN EL VALOR DEFAULT Y LAS DEFINICIONES
    newGroup.forEach((group) => {
      group.questions.forEach((itemCurrent) => {
        const value = itemCurrent.Value;

        const matchedDefinition = itemCurrent.ExecuteSearchDefinition?.find(
          (opt) => opt.Option === value
        );

        matchedDefinition?.Requiered?.forEach((requiredItem) => {
          newGroup = newGroup.map((group) =>
            group.groupTitle.toUpperCase() ===
            requiredItem.QuestionGroup.toUpperCase()
              ? {
                  ...group,
                  questions: group.questions.map((question) =>
                    question.Name.toUpperCase() ===
                    requiredItem.Question.toUpperCase()
                      ? { ...question, Visible: requiredItem.Requiered }
                      : question
                  ),
                }
              : group
          );
        });
      });
    });

    return newGroup;
  };

  let SubmitForm = (formData) => {
    const generalMetadata = questions.map((itemGroup, i) => {
      let itemsQuestions = itemGroup.questions.map((itemQuestion, i) => {
        return {
          ...itemQuestion,
          Value:
            itemQuestion.QuestionType == "Currency" && itemQuestion.Visible
              ? formData[`${itemQuestion.Id}`]
                  ?.replace("$", "")
                  ?.replace(",", "")
                  ?.replace(",", "")
              : itemQuestion.Visible
              ? formData[`${itemQuestion.Id}`]
              : null,
        };
      });
      return {
        ...itemGroup,
        questions: itemsQuestions,
      };
    });

    let filtroPreguntas = generalMetadata?.find(
      (item) => item.groupTitle == "Nomina"
    )?.questions;
    if (
      filtroPreguntas
        ?.find(
          (item) =>
            item.Name == "¿Desea agregar beneficiarios para su Seguro de Vida?"
        )
        ?.Value?.toUpperCase() == "SI"
    ) {
      let ValueCount = filtroPreguntas
        .filter((item) => item.Name.includes("% Asignado"))
        ?.reduce((accumulator, currentValue) => {
          let currentValueFind = 0;
          try {
            currentValueFind =
              currentValue.Value === undefined ||
              currentValue.Value === null ||
              currentValue.Value == ""
                ? 0
                : parseInt(currentValue.Value);
          } catch (e) {
            console.log("Error: currentValueFind: ", e);
          }
          return accumulator + currentValueFind;
        }, 0);

      if (ValueCount > 100) {
        Alert({
          icon: 0,
          title: "el monto no debe rebasar el 100 %",
          timer: 4000,
        });
        return;
      } else if (ValueCount < 100) {
        Alert({
          icon: 0,
          title: "el monto no debe ser menor al 100 %",
          timer: 4000,
        });
        return;
      }
    }

    let obj = {
      ObjectId: folio,
      Actor_Id: actorId,
      Metadata: coreFunctions.GetResponsens(generalMetadata),
      ContinueWorkFlow: true,
    };
    dispatch(fileActions.UpdateMetadata(obj));
    reset();
    setSaveAction(true);

    // // setLoadView(true);
  };

  useEffect(() => {
    const firstError = Object.keys(errors).reduce((field, a) => {
      return !!errors[field] ? field : a;
    }, null);

    if (firstError) {
      setExpanded(false);
      let textData = questions.filter(
        (itemGroup) =>
          itemGroup.questions.filter((itemQ) => itemQ.Id == firstError).length >
          0
      );
      setExpanded(textData[0].llave);
      setFocus(firstError);
    }
  }, [errors, setFocus, submitCount]);

  useEffect(() => {
    if (questions?.length > 0) {
      if (initLoadCombos) {
        questions.forEach((itemGroup) => {
          itemGroup.questions?.forEach((itemQuestion) => {
            if (itemQuestion.QuestionType == "Fecha") {
              if (
                itemQuestion.Metadata != null ||
                itemQuestion.Metadata !== undefined
              ) {
                const fechaCorrecta = parseDate(itemQuestion.Metadata?.Value);
                setValue(
                  `${itemQuestion.Id}`,
                  itemQuestion.Metadata !== null ? fechaCorrecta : ""
                );
              }
            } else if (
              itemQuestion.QuestionType === "FechaPrevia" ||
              itemQuestion.QuestionType === "FechaPosterior"
            ) {
              if (
                itemQuestion.Metadata != null ||
                itemQuestion.Metadata !== undefined
              ) {
                const fechaCorrecta = parseDate(itemQuestion.Metadata?.Value);
                setValue(
                  `${itemQuestion.Id}`,
                  itemQuestion.Metadata !== null ? fechaCorrecta : ""
                );
              }
            } else if (itemQuestion.QuestionType === "Radio") {
              let defaultValue =
                itemQuestion.Metadata !== undefined &&
                itemQuestion.Metadata !== null
                  ? itemQuestion.Metadata?.Value
                  : itemQuestion?.Value !== undefined &&
                    itemQuestion?.Value !== null &&
                    itemQuestion?.Value !== ""
                  ? itemQuestion?.Value
                  : "";

                  if (!defaultValue) return null

              setValue(`${itemQuestion.Id}`, defaultValue, {
                shouldValidate: true,
              });
            } else {
              setValue(`${itemQuestion.Id}`, itemQuestion.Value);
              changeNames(itemQuestion, "");
            }
          });
        });
      }

      if (expanded == "") {
        setExpanded(questions.length > 0 ? questions[0].llave : false);
      }
      setInitLoadCombos(false);
      clearErrors();
    }
  }, [questions]);
  

  useEffect(() => {
    if (dataSearchCP.items != undefined && loadPostalCode) {
      setLoadPostalCode(false);
      let listColonia = dataSearchCP.items?.Body?.find(
        (item) =>
          item.Question == "Colonia" &&
          item.QuestionGroup == "Comprobante de domicilio"
      )?.Values;
      setListColoniaCurrent(listColonia);

      let listCiudad = dataSearchCP.items?.Body?.find(
        (item) =>
          item.Question == "Ciudad" &&
          item.QuestionGroup == "Comprobante de domicilio"
      )?.Values[0];

      let listMunicipio = dataSearchCP.items?.Body?.find(
        (item) =>
          item.Question == "Municipio" &&
          item.QuestionGroup == "Comprobante de domicilio"
      )?.Values[0];

      let listEstado = dataSearchCP.items?.Body?.find(
        (item) =>
          item.Question == "Estado" &&
          item.QuestionGroup == "Comprobante de domicilio"
      )?.Values[0];

      setValue("Ciudad", listCiudad);
      setValue("Municipio", listMunicipio);
      setValue("Estado", listEstado);
      setValue("Colonia", listColonia[0]);
    } else if (dataSearchCP.error != undefined && loadPostalCode) {
      setLoadPostalCode(false);
    }
  }, [dataSearchCP]);

  let GetFindPostalCode = (code, name, group) => {
    if (code != null && code != "" && code?.length > 4) {
      setLoadPostalCode(true);
      let data = {
        File_Id: null,
        Document_Id: null,
        DocumentType_Id: props.docId,
        QuestionGroup: "Comprobante de domicilio",
        Question: `${name}`,
        Value: `${code}`,
      };
      dispatch(executeSearchActions.GetByCodigoPostal(data));
    }
  };


  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  let UpdateCtrlQuestions = async (itemCurrent, valueParam) => {
    console.log('itemCurrent', itemCurrent, valueParam)
    if (itemCurrent.ExecuteSearchFunction == "GetBySelectedOption") {
      setLoadViewCtrls(true);
      let value =
        valueParam === undefined || valueParam === null || valueParam === ""
          ? watch(`${itemCurrent.Id}`)
          : valueParam;
      let request = {
        File_Id: folio,
        Document_Id: null,
        DocumentType_Id: null,
        QuestionGroup: itemCurrent.QuestionGroup,
        Question: itemCurrent.Name,
        Value: value,
      };
      await executeSearchRequests
        .GetBySelectedOption(request)
        .then((response) => {
          let arrayOriginal = questions;

          response.Body?.forEach((itemQuestion) => {
            let listOptions = itemQuestion?.Values.map((item) => {
              return {
                Option: item,
                Value: item,
              };
            });
            let valueSaved = watch(`${itemCurrent.Name}`);
            const updatedOSArray = arrayOriginal.map((itemGroup) =>
              itemGroup.groupTitle.toUpperCase() ===
              itemQuestion.QuestionGroup.toUpperCase()
                ? {
                    ...itemGroup,
                    questions: itemGroup.questions.map((itemQ) =>
                      itemQ.Name.toUpperCase() ===
                      itemQuestion.Question.toUpperCase()
                        ? { ...itemQ, Options: listOptions }
                        : itemQ.Name.toUpperCase() ===
                          itemCurrent.Name.toUpperCase()
                        ? { ...itemQ, Value: value }
                        : { ...itemQ, Value: watch(`${itemQ.Id}`) }
                    ),
                  }
                : {
                    ...itemGroup,
                    questions: itemGroup.questions.map((itemQ) =>
                      itemQ.Name.toUpperCase() ===
                      itemCurrent.Name.toUpperCase()
                        ? { ...itemQ, Value: value }
                        : { ...itemQ, Value: watch(`${itemQ.Id}`) }
                    ),
                  }
            );
            arrayOriginal = updatedOSArray;
          });
          setQuestions([]);
          console.log(
            "Llenado setQuestions:----------2----------------: ",
            arrayOriginal
          );
          setQuestions(arrayOriginal);
          setLoadViewCtrls(false);
        });
      // console.log("Execute fin de peticion")
      // clearErrors()
    } else if (itemCurrent.ExecuteSearchFunction === "GetPreguntasRequeridas") {
      console.log('itemCurrent', itemCurrent, valueParam)
      const value =
        valueParam === undefined || valueParam === null || valueParam === ""
          ? watch(`${itemCurrent.Id}`)
          : valueParam;

      let updatedQuestions = questions;

      // Buscar la definición correspondiente al valor seleccionado
      const matchedDefinition = itemCurrent.ExecuteSearchDefinition?.find(
        (opt) => opt.Option === value
      );

      // Actualizar visibilidad según la definición
      matchedDefinition?.Requiered?.forEach((requiredItem) => {
        updatedQuestions = updatedQuestions.map((group) =>
          group.groupTitle.toUpperCase() ===
          requiredItem.QuestionGroup.toUpperCase()
            ? {
                ...group,
                questions: group.questions.map((question) =>
                  question.Name.toUpperCase() ===
                  requiredItem.Question.toUpperCase()
                    ? { ...question, Visible: requiredItem.Requiered }
                    : question
                ),
              }
            : group
        );
      });

      // Limpiar errores si la pregunta no es visible y actualizar el valor de itemCurrent
      const newUpdateArray = updatedQuestions.map((group) =>
        group.groupTitle.toUpperCase() === itemCurrent.GroupName.toUpperCase()
          ? {
              ...group,
              questions: group.questions.map((question) => {
                if (!question.Visible) clearErrors(`${question.Id}`);
                return question.Name.toUpperCase() ===
                  itemCurrent.Name.toUpperCase()
                  ? { ...question, Value: value }
                  : question;
              }),
            }
          : group
      );

      setQuestions(null); // Reset previo (si necesario)
      setQuestions(newUpdateArray);

      // Actualizar reglas de la pregunta padre si es necesario.
      const groupParentDef = itemCurrent.ExecuteSearchDefinition?.find(
        (def) =>
          def.QuestionGroupParent !== undefined &&
          def.QuestionParent !== undefined
      );

      if (groupParentDef && (value === "NO" || value === "NÃO")) {
        const QuestionParent = groupParentDef?.QuestionParent;
        const QuestionGroupParent = groupParentDef?.QuestionGroupParent;

        let itemCurrentParent = questions
          .find((item) => item.groupTitle === QuestionGroupParent)
          ?.questions?.find((item) => item.Name === QuestionParent);
        UpdateCtrlQuestions(itemCurrentParent, itemCurrentParent.Value);
        // UpdateCtrlQuestions(itemCurrent, value);
      }
    } else if (itemCurrent.ExecuteSearchFunction === "GetBySelectFilter") {
      let value =
        valueParam === undefined || valueParam === null || valueParam === ""
          ? watch(`${itemCurrent.Id}`)
          : valueParam;
      if (value !== undefined && value !== null && value !== "") {
        setLoadViewCtrls(true);
        let requestConsult = {
          File_Id: folio,
          QuestionGroup:
            itemCurrent?.ExecuteSearchDefinition[0]?.FilterQuestion
              ?.QuestionGroup,
          Question:
            itemCurrent?.ExecuteSearchDefinition[0]?.FilterQuestion?.Question,
          FilterColumn: itemCurrent?.ExecuteSearchDefinition[0]?.MetadataFilter,
          FilterValue: value,
        };
        await executeSearchRequests
          .GetByCustomCatalogAsync(requestConsult)
          .then((response) => {
            let arrayOriginal = questions;
            var QuestionResponse = response.Body;
            let listOptions = QuestionResponse?.Values?.map((item) => {
              return {
                Option: item,
                Value: item,
              };
            });
            const updatedOSArray = arrayOriginal.map((itemGroup) =>
              itemGroup.groupTitle.toUpperCase() ===
              QuestionResponse.QuestionGroup.toUpperCase()
                ? {
                    ...itemGroup,
                    questions: itemGroup.questions.map((itemQ) =>
                      itemQ.Name.toUpperCase() ===
                      QuestionResponse.Question.toUpperCase()
                        ? {
                            ...itemQ,
                            Options:
                              listOptions?.length > 0
                                ? listOptions
                                : itemQ.Options,
                            Value: QuestionResponse?.Values[0],
                            QuestionType: "AutoComplete",
                          }
                        : itemQ.Name.toUpperCase() ===
                          itemCurrent.Name.toUpperCase()
                        ? { ...itemQ, Value: value }
                        : itemQ
                    ),
                  }
                : itemGroup
            );
            arrayOriginal = updatedOSArray;

            itemCurrent?.ExecuteSearchDefinition[0]?.OptionsRequiered?.forEach(
              (itemRequired) => {
                if (
                  ValidarSICumpleCondiciones(
                    itemRequired.Operador,
                    value,
                    itemRequired.Option
                  )
                ) {
                  itemRequired?.Requiered?.forEach((itemQuestion) => {
                    const updatedOSArray = arrayOriginal.map((itemGroup) =>
                      itemGroup.groupTitle.toUpperCase() ===
                      itemQuestion.QuestionGroup.toUpperCase()
                        ? {
                            ...itemGroup,
                            questions: itemGroup.questions.map((itemQ) =>
                              itemQ.Name.toUpperCase() ===
                              itemQuestion.Question.toUpperCase()
                                ? { ...itemQ, Visible: itemQuestion.Requiered }
                                : itemQ
                            ),
                          }
                        : itemGroup
                    );
                    arrayOriginal = updatedOSArray;
                  });

                  let newUpdatearray = arrayOriginal.map((itemGroup) =>
                    itemGroup.groupTitle.toUpperCase() ===
                    itemCurrent.GroupName.toUpperCase()
                      ? {
                          ...itemGroup,
                          questions: itemGroup.questions.map((itemQ) =>
                            itemQ.Name.toUpperCase() ===
                            itemCurrent.Name.toUpperCase()
                              ? { ...itemQ, Value: value }
                              : itemQ
                          ),
                        }
                      : itemGroup
                  );
                  arrayOriginal = newUpdatearray;
                }
              }
            );
            setExpandedCurrent(itemCurrent.QuestionGroupId);
            setQuestions(null);
            setQuestions(arrayOriginal);
            setLoadViewCtrls(false);
          })
          .catch((error) => {
            console.log(error);
            setLoadViewCtrls(false);
          });
      }
      // clearErrors()
    }

    // clearErrors()
    clearErrors(`${itemCurrent.Id}`);
    setExpanded(itemCurrent.QuestionGroupId);
  };

  let InitCtrlRequiredQuestions = async (itemCurrent) => {
    if (itemCurrent.ExecuteSearchFunction === "GetPreguntasRequeridas" && itemCurrent.QuestionType === "Radio") {
      const value =
        itemCurrent.Value === undefined || itemCurrent.Value === null || itemCurrent.Value === ""
          ? watch(`${itemCurrent.Id}`)
          : itemCurrent.Value;

      let updatedQuestions = questions;

      // Buscar la definición correspondiente al valor seleccionado
      const matchedDefinition = itemCurrent.ExecuteSearchDefinition?.find(
        (opt) => opt.Option === value
      );

      // Actualizar visibilidad según la definición
      matchedDefinition?.Requiered?.forEach((requiredItem) => {
        updatedQuestions = updatedQuestions.map((group) =>
          group.groupTitle.toUpperCase() ===
          requiredItem.QuestionGroup.toUpperCase()
            ? {
                ...group,
                questions: group.questions.map((question) =>
                  question.Name.toUpperCase() ===
                  requiredItem.Question.toUpperCase()
                    ? { ...question, Visible: requiredItem.Requiered }
                    : question
                ),
              }
            : group
        );
      });

      // Limpiar errores si la pregunta no es visible y actualizar el valor de itemCurrent
      const newUpdateArray = updatedQuestions.map((group) =>
        group.groupTitle.toUpperCase() === itemCurrent.GroupName.toUpperCase()
          ? {
              ...group,
              questions: group.questions.map((question) => {
                if (!question.Visible) clearErrors(`${question.Id}`);
                return question.Name.toUpperCase() ===
                  itemCurrent.Name.toUpperCase()
                  ? { ...question, Value: value }
                  : question;
              }),
            }
          : group
      );

     // setQuestions(null); // Reset previo (si necesario)
      setQuestions(newUpdateArray);

      /* // Actualizar reglas de la pregunta padre si es necesario.
      const groupParentDef = itemCurrent.ExecuteSearchDefinition?.find(
        (def) =>
          def.QuestionGroupParent !== undefined &&
          def.QuestionParent !== undefined
      );

      if (groupParentDef && (value === "NO" || value === "NÃO")) {
        const QuestionParent = groupParentDef?.QuestionParent;
        const QuestionGroupParent = groupParentDef?.QuestionGroupParent;

        let itemCurrentParent = questions
          .find((item) => item.groupTitle === QuestionGroupParent)
          ?.questions?.find((item) => item.Name === QuestionParent);
        UpdateCtrlQuestions(itemCurrentParent, itemCurrentParent.Value);
        // UpdateCtrlQuestions(itemCurrent, value);
      } */
    }

    clearErrors(`${itemCurrent.Id}`);
    setExpanded(itemCurrent.QuestionGroupId);
  };

  const initialized = React.useRef(false); //bandera para evitar loop

  React.useEffect(() => {
    if (!initialized.current && questions.length > 0) {
      questions.forEach(question => {
        question.questions.every(q => q.Visible && InitCtrlRequiredQuestions(q));
      });

      initialized.current = true;
    }
  }, [questions]);

  const changeNames = (itemCurrent, valueParam) => {
    const dataValues = questions.find(
      (item) => item.groupTitle === "Candidato"
    )?.questions;

    if (dataValues !== undefined && dataValues.length > 0) {
      const primerNombreData = watch(
        `${dataValues?.find((itemQ) => itemQ.Name === "Primer Nombre")?.Id}`
      );
      const segundoNombreData = watch(
        `${dataValues?.find((itemQ) => itemQ.Name === "Segundo Nombre")?.Id}`
      );
      const primerApellidoData = watch(
        `${dataValues?.find((itemQ) => itemQ.Name === "Primer Apellido")?.Id}`
      );
      const segundoApellidoData = watch(
        `${dataValues?.find((itemQ) => itemQ.Name === "Segundo Apellido")?.Id}`
      );

      if (itemCurrent.Name === "Nombre Preferido") {
        let newArrayNames = [];
        if (segundoNombreData != null && segundoNombreData != undefined) {
          newArrayNames = [
            {
              Option: primerNombreData,
              Value: primerNombreData,
            },
            {
              Option: segundoNombreData,
              Value: segundoNombreData,
            },
          ];
        } else {
          newArrayNames = [
            {
              Option: primerNombreData,
              Value: primerNombreData,
            },
          ];
        }

        let newArrayApellidos = [
          {
            Option: primerApellidoData,
            Value: primerApellidoData,
          },
          {
            Option: segundoApellidoData,
            Value: segundoApellidoData,
          },
        ];
        let arrayOriginal = questions;
        let newUpdatearray = arrayOriginal.map((itemGroup) =>
          itemGroup.groupTitle.toUpperCase() ===
          itemCurrent.GroupName.toUpperCase()
            ? {
                ...itemGroup,
                questions: itemGroup.questions.map((itemQ) =>
                  itemQ.Name === "Nombre Preferido"
                    ? { ...itemQ, Options: newArrayNames }
                    : itemQ.Name === "Apellido Preferido"
                    ? { ...itemQ, Options: newArrayApellidos }
                    : itemQ
                ),
              }
            : itemGroup
        );
        setQuestions(null);
        setQuestions(newUpdatearray);
      }
    }
  };

  const changeNameInputs = (itemCurrent) => {
    const dataValues = questions.filter(
      (item) => item.groupTitle === "Candidato"
    )[0]?.questions;
    if (dataValues !== undefined && dataValues.length > 0) {
      const primerNombreData = watch(
        `${dataValues?.find((itemQ) => itemQ.Name === "Primer Nombre")?.Id}`
      );
      const segundoNombreData = watch(
        `${dataValues?.find((itemQ) => itemQ.Name === "Segundo Nombre")?.Id}`
      );
      const primerApellidoData = watch(
        `${dataValues?.find((itemQ) => itemQ.Name === "Primer Apellido")?.Id}`
      );
      const segundoApellidoData = watch(
        `${dataValues?.find((itemQ) => itemQ.Name === "Segundo Apellido")?.Id}`
      );

      if (
        itemCurrent.Name === "Primer Nombre" ||
        itemCurrent.Name === "Segundo Nombre"
      ) {
        let newArrayNames = [
          {
            Option: primerNombreData,
            Value: primerNombreData,
          },
          {
            Option: segundoNombreData,
            Value: segundoNombreData,
          },
        ];
        let arrayOriginal = questions;
        let newUpdatearray = arrayOriginal.map((itemGroup) =>
          itemGroup.groupTitle === "Información Personal"
            ? {
                ...itemGroup,
                questions: itemGroup.questions.map((itemQ) =>
                  itemQ.Name === "Nombre Preferido"
                    ? { ...itemQ, Options: newArrayNames }
                    : itemQ
                ),
              }
            : itemGroup
        );
        setQuestions(null);
        setQuestions(newUpdatearray);
      } else if (
        itemCurrent.Name === "Primer Apellido" ||
        itemCurrent.Name === "Segundo Apellido"
      ) {
        let newArrayApellidos = [
          {
            Option: primerApellidoData,
            Value: primerApellidoData,
          },
          {
            Option: segundoApellidoData,
            Value: segundoApellidoData,
          },
        ];
        let arrayOriginal = questions;

        let newUpdatearray = arrayOriginal.map((itemGroup) =>
          itemGroup.groupTitle === "Información Personal"
            ? {
                ...itemGroup,
                questions: itemGroup.questions.map((itemQ) =>
                  itemQ.Name === "Apellido Preferido"
                    ? { ...itemQ, Options: newArrayApellidos }
                    : itemQ
                ),
              }
            : itemGroup
        );
        setQuestions(null);
        setQuestions(newUpdatearray);
      }
    }
  };

  console.log('formStateformState', formState.errors)

  const validacionBancoDatos = () => {
    // let questionGrupo = questions.find((itemG) => itemG.groupTitle == itemCurrent.ExecuteSearchDefinition[0].QuestionParent.QuestionGroup)
    let questionPadreComparation = null;
    let objetoContenedor = null;

    for (let i = 0; i < questions.length; i++) {
      const question = questions[i];

      // Busca la pregunta con el tipo 'GetQuestionCompare' dentro de 'question.questions'
      const foundQuestion = question?.questions?.find(
        (item) => item.ExecuteSearchFunction === "GetQuestionCompare"
      );

      // Si se encuentra la pregunta, haz algo con ella
      if (foundQuestion) {
        questionPadreComparation = foundQuestion;
        objetoContenedor = question;
        break; // Termina el bucle una vez encontrada la pregunta
      }
    }

    //let questionPadreComparation = questions[0].questions.find((item) => item.ExecuteSearchFunction == "GetQuestionCompare")
    if (questionPadreComparation) {
      let questionPadre = objetoContenedor.questions.find(
        (item) =>
          item.Name ==
          questionPadreComparation.ExecuteSearchDefinition[0].QuestionParent
            .Question
      );
      const valueData = watch(`${questionPadre.Id}`);

      let comparationQuestion =
        questionPadreComparation.ExecuteSearchDefinition[0].Comparacion.find(
          (item) => item.Value == valueData
        );

      let totalSum = 0; // Inicializamos la variable para almacenar la suma total
      // Iterar sobre el array de preguntas

      comparationQuestion.QuestionsCompare.forEach((question) => {
        // Buscar el objeto en el array de preguntas dentro de data
        const questionObject = objetoContenedor.questions.find(
          (item) => item.Name.toUpperCase() === question.Question.toUpperCase()
        );

        if (questionObject) {
          // Aplicar un "watch" a cada objeto para obtener su valor
          const valueData = watch(`${questionObject.Id}`);

          // Convertir el valor obtenido a un número y sumarlo al total
          totalSum += parseFloat(valueData);
        }
      });
      let totalComparar =
        questionPadreComparation.ExecuteSearchDefinition[0].Total;

      if (totalSum == totalComparar) {
        return true;
      } else {
        const normalizeText = (str) => {
          return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        };
        comparationQuestion.QuestionsCompare.forEach((question) => {
          // Buscar el objeto en el array de preguntas dentro de data
          const questionObject = objetoContenedor.questions.find(
            (item) =>
              normalizeText(item.GroupName) ===
                normalizeText(question.QuestionGroup) &&
              item.Name === question.Question
          );
          if (questionObject) {
            setError(`${questionObject.Id}`, {
              type: "required",
              message: "Valida que la suma de los porcentajes sea igual a 100%",
            });

            // Aplicar un "watch" a cada objeto para obtener su valor
          }
        });
        return false;
      }
    }
  };

  const handleOpenInfo = (e) => {
    /* Mensaje para funcionarios publicos flujo colombia */
    /* Mensaje para funcionarios publicos flujo colombia */
    e.stopPropagation();
    Alert({
      icon: "info",
      okbtntext: "Ok",
      html: (
        <Typography sx={{ fontSize: { xs: 12, md: 14 }, textAlign: "justify" }}>
          <b>Funcionario Público:</b> Para Colombia se debe considerar como
          Persona Políticamente expuesta de acuerdo al decreto 830 de 2021 los
          cuales son aquellas personas que desempeñan o han desempeñado (que
          hayan dejado su cargo hace menos de 2 años), altos cargos en el poder
          ejecutivo, judicial o electoral, en la administración pública, las
          fuerzas militares, los directores y tesoreros de patrimonios autónomos
          o fidecomisos que administran recursos públicos, representantes
          legales, presidentes, directores y tesoreros de movimientos y partidos
          políticos, así como los representantes legales de organizaciones
          internacionales o ejerce funciones directivas en una organización
          internacional) directores, subdirectores, miembros de juntas
          directivas o cualquier persona que ejerza una función equivalente), o
          que ocupen cargos políticos destacados en otro país. Así mismo el
          vínculo familiar se entiende como sociedad conyugal, de hecho, o de
          derecho, familiares hasta el segundo grado de consanguinidad (padres,
          hijos, hermanos, abuelos, nietos), Segundo de afinidad: padres y
          hermanos del cónyuge (suegros y cuñados), cónyuge de hijo o hija
          (nuera y yerno) y/o hijos del cónyuge que no sean propios (entenados),
          Primero civil (hijos adoptivos o padres adoptantes).
        </Typography>
      ),
    });
  };

  return (
    <GenericContainer>
      <FormProvider {...formMethods}>
        {loadView ? (
          <CustomLoadingOverlay
            active={loadView}
            text={t("general_loading_message")}
          />
        ) : null}
        {/* <Typography variant="h6" gutterBottom >
                {title}
            </Typography> */}
        <Typography variant="subtitle">
          {editableForm === true
            ? t("info_person_form_verification")
            : /* textSubtitle ?? */ t("info_person_form")}
        </Typography>
        {console.log("questions", questions)}
        {questions?.length > 0 ? (
          <GenericContainerForm>
            {loadViewCtrls ? (
              <CustomLoadingOverlay
                active={loadViewCtrls}
                text={t("general_loading_message")}
              />
            ) : null}
            {questions.length > 0 &&
              questions.map((itemGroup, indexGroup) =>
                itemGroup.questions.every(
                  (question) => !question.Visible
                ) ? null : (
                  <Accordion
                    key={indexGroup + "1"}
                    expanded={
                      questions.length > 1 ? expanded === itemGroup.llave : true
                    }
                    onChange={handleChange(itemGroup.llave)}
                  >
                    <AccordionSummary
                      expandIcon={
                        questions.length > 1 ? <ExpandMoreIcon /> : null
                      }
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      {(file.items?.WorkFlow?.Id === 4 ||
                        file.items?.WorkFlow?.Id === 6) &&
                      (itemGroup.llave === 489 || itemGroup.llave === 397) ? (
                        <IconButton size="small" onClick={handleOpenInfo}>
                          <Info color="primary" />
                        </IconButton>
                      ) : null}
                      <Typography variant="h6" id={itemGroup.llave}>
                        {itemGroup.description}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "0px 16px 16px !important",
                        // minHeight: '28vh',
                      }}
                    >
                      {itemGroup.questions?.map((itemInput, indexInput) => {
                        if (itemInput.Visible === false) return null;
                        switch (itemInput.QuestionType.toUpperCase()) {
                          case "TEXTO":
                            return (
                              <Controller
                                control={control}
                                name={`${itemInput.Id}`}
                                render={({ field: { ref, ...restFields } }) =>
                                  itemInput.Name == "Código Postal" ? (
                                    <TextField
                                      {...restFields}
                                      {...register(`${itemInput.Id}`, {
                                        required: "Requerido",
                                        minLength: {
                                          value: 5,
                                          message: "Código Postal. ej. 54960",
                                        },
                                      })}
                                      required={itemInput.Required}
                                      error={
                                        !!formState.errors[`${itemInput.Id}`]
                                      }
                                      helperText={
                                        formState.errors[`${itemInput.Id}`]
                                          ?.message
                                      }
                                      inputRef={ref}
                                      fullWidth
                                      autoComplete="new-password"
                                      variant="outlined"
                                      disabled={itemInput.Disabled}
                                      placeholder={itemInput.Description}
                                      label={itemInput.Description}
                                      onBlur={(e) =>
                                        GetFindPostalCode(
                                          e.target.value,
                                          `${itemInput.Id}`,
                                          itemInput.GroupName
                                        )
                                      }
                                      onKeyDown={(e) =>
                                        GetFindPostalCode(
                                          e.target.value,
                                          `${itemInput.Id}`,
                                          itemInput.GroupName
                                        )
                                      }
                                      InputProps={{
                                        inputProps: {
                                          maxLength: 5,
                                          style: { textTransform: "uppercase" },
                                          outline: "none",
                                          autoComplete: "new-password",
                                          form: {
                                            autoComplete: "off",
                                          },
                                        },
                                      }}
                                    />
                                  ) : (
                                    <InputField
                                      inputType="text"
                                      control={control}
                                      register={register}
                                      name={`${itemInput.Id}`}
                                      regexGeneric={itemInput.RegularExpression}
                                      label={itemInput.Description}
                                      validations={{
                                        required: itemInput.Required,
                                      }}
                                      defaultValue={itemInput.Value}
                                      error={
                                        !!formState.errors[`${itemInput.Id}`]
                                      }
                                      helperText={
                                        formState.errors[`${itemInput.Id}`]
                                          ?.message
                                      }
                                      required={itemInput.Required}
                                      disabled={itemInput.Disabled}
                                      placeholder={itemInput.Description}
                                      onBlur={(e) =>
                                        changeNameInputs(
                                          itemInput,
                                          e.target.value
                                        )
                                      }
                                    />
                                  )
                                }
                              />
                            );
                          case "PHONE":
                            const validatePhoneNumber = (number, minLength) => {
                              console.log(
                                "Validate Format Phone: ",
                                number,
                                minLength
                              );
                              return (
                                number?.replace(/\D/g, "").length >=
                                  minLength || "Número de teléfono incompleto"
                              );
                            };
                            console.log("itemInput......", itemInput);
                            return (
                              <InputField
                                inputType="phone"
                                phoneRegular={itemInput?.RegularExpression}
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{
                                  required: itemInput.Required,
                                  validate: (e) =>
                                    validatePhoneNumber(
                                      e,
                                      itemInput?.Length ?? 12
                                    ),
                                }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                                placeholder={itemInput.Description}
                                /* onSelect={(value, format)=>{
                                                    const minLength = format?.split('').filter(char => char === '.').length
                                                    const result = validatePhoneNumber(value, minLength)
                                                    if(result === true){
                                                        console.log('Entro a clear')
                                                        clearErrors(`${itemInput.Id}`)
                                                    }else{
                                                        console.log('Entro a error',itemInput.Id)
                                                        setError(`${itemInput.Id}`, result)
                                                    }
                                                    console.log('ASDLLL', result,format)
                                                }} */
                              />
                            );
                          case "TEXTAREA":
                            return (
                              <InputField
                                inputType="text"
                                control={control}
                                register={register}
                                multiline={true}
                                minRows={3}
                                name={`${itemInput.Id}`}
                                regexGeneric={itemInput.RegularExpression}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                defaultValue={itemInput.Value}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                                placeholder={itemInput.Description}
                                onBlur={(e) =>
                                  changeNameInputs(itemInput, e.target.value)
                                }
                              />
                            );
                          case "NUMBER":
                            return (
                              <InputField
                                inputType="number"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                                onBlur={(value) =>
                                  UpdateCtrlQuestions(itemInput, value)
                                }
                                // onKeyDown={(value) => UpdateCtrlQuestions(itemInput, value)}
                              />
                            );
                          case "CLABE":
                            return (
                              <InputField
                                inputType="clabe"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "AUTOCOMPLETE":
                            return (
                              <InputField
                                inputType="autocomplete"
                                control={control}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                placeholder={itemInput.Description}
                                defaultValue={itemInput.Value}
                                optionsList={itemInput.Options}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                onClose={(e) => console.log("looog", e)}
                                onSelect={(e) => {
                                  setValue(`${itemInput.Id}`, e);
                                  UpdateCtrlQuestions(itemInput, "");
                                }}
                                onInputChange={(e, searchValue) => {}}
                              />
                            );
                          case "EMAILMETLIFE":
                            return (
                              <InputField
                                inputType="emailMetlife"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "EMAIL":
                            return (
                              <InputField
                                inputType="email"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "RADIO":
                            return (
                              <InputField
                                inputType="radio"
                                control={control}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                radioValues={
                                  itemInput.Options?.sort((a, b) =>
                                    b.Option.localeCompare(a.Option)
                                  ) || []
                                }
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                onSelect={(e, value) => {
                                  console.log('valuevalue', itemInput, value)
                                  clearErrors(`${itemInput.Id}`);
                                  setValue(`${itemInput.Id}`, value, {
                                    shouldValidate: true,
                                  });
                                  UpdateCtrlQuestions(itemInput, value);
                                }}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "CHECKBOX":
                            return (
                              <InputField
                                inputType="check"
                                control={control}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                radioValues={itemInput.Options}
                                required={itemInput.Required}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                              />
                            );
                          case "COMBO":
                            return (
                              <InputField
                                inputType="select"
                                register={register}
                                control={control}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                optionsList={itemInput.Options}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={true /* itemInput.Required */}
                                // onClick={(e) => console.log('Cambios', e)}
                                onSelect={(e) => {
                                  clearErrors(`${itemInput.Id}`);
                                  setValue(`${itemInput.Id}`, e.target.value, {
                                    shouldValidate: true,
                                  });
                                  UpdateCtrlQuestions(itemInput, "");
                                }}
                                disabled={itemInput.Disabled}
                                placeholder={itemInput.Description}
                                // error={!!formState.errors[`${itemInput.Id}`]}
                              />
                            );
                          case "FECHA":
                            return (
                              <InputField
                                inputType="date"
                                register={register}
                                control={control}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                onSelect={(e) => {
                                  clearErrors(`${itemInput.Id}`);
                                  setValue(`${itemInput.Id}`, e);
                                }}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "FECHAPREVIA":
                            return (
                              <InputField
                                inputType="date"
                                register={register}
                                control={control}
                                maxDate={new Date()}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                defaultValue={itemInput.Value}
                                required={itemInput.Required}
                                onSelect={(e) => {
                                  clearErrors(`${itemInput.Id}`);
                                  setValue(`${itemInput.Id}`, e);
                                }}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "FECHAPOSTERIOR":
                            return (
                              <InputField
                                inputType="date"
                                register={register}
                                control={control}
                                minDate={new Date()}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                onSelect={(e) => {
                                  clearErrors(`${itemInput.Id}`);
                                  setValue(`${itemInput.Id}`, e);
                                }}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "CURRENCY":
                            return (
                              <InputField
                                inputType="currency"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                placeholder={itemInput.Description}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                                onSelect={(e) => {
                                  setValue(`${itemInput.Id}`, e);
                                  clearErrors(`${itemInput.Id}`);
                                }}
                              />
                            );
                          case "HOUR":
                            return (
                              <InputField
                                inputType="hour"
                                register={register}
                                control={control}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "POSTALCODE":
                            return (
                              <InputField
                                inputType="PostalCode"
                                register={register}
                                control={control}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                disabled={itemInput.Disabled}
                              />
                            );
                          case "LABEL":
                            return (
                              <InputField
                                inputType="label"
                                label={itemInput.Description}
                              />
                            );
                          case "TEXTLETTER":
                            return (
                              <InputField
                                inputType="textLetter"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ validate: true }}
                                defaultValue={itemInput.Value}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                maxLength={itemInput.Length}
                              />
                            );
                          case "RFC":
                            return (
                              <InputField
                                inputType="rfc"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                defaultValue={itemInput.Value}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                              />
                            );
                          case "CURP":
                            return (
                              <InputField
                                inputType="curp"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ required: itemInput.Required }}
                                defaultValue={itemInput.Value}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                              />
                            );
                          case "ALPHANUMERIC":
                            return (
                              <InputField
                                inputType="alphanumeric"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ validate: true }}
                                defaultValue={itemInput.Value}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                maxLength={itemInput.Length}
                              />
                            );
                          case "PERCENTAGE":
                            return (
                              <InputField
                                inputType="percentage"
                                control={control}
                                register={register}
                                name={`${itemInput.Id}`}
                                label={itemInput.Description}
                                validations={{ validate: true }}
                                defaultValue={itemInput.Value}
                                error={!!formState.errors[`${itemInput.Id}`]}
                                helperText={
                                  formState.errors[`${itemInput.Id}`]?.message
                                }
                                required={itemInput.Required}
                                maxLength={itemInput.Length}
                              />
                            );
                          default:
                            return (
                              <Controller
                                control={control}
                                name={`${itemInput.Id}`}
                                render={({ field: { ref, ...restFields } }) =>
                                  itemInput.Name == "Código Postal" ? (
                                    <TextField
                                      {...restFields}
                                      {...register(`${itemInput.Id}`, {
                                        required: "Requerido",
                                        minLength: {
                                          value: 5,
                                          message: "Código Postal. ej. 54960",
                                        },
                                      })}
                                      required={itemInput.Required}
                                      error={
                                        !!formState.errors[`${itemInput.Id}`]
                                      }
                                      helperText={
                                        formState.errors[`${itemInput.Id}`]
                                          ?.message
                                      }
                                      inputRef={ref}
                                      fullWidth
                                      autoComplete="new-password"
                                      variant="outlined"
                                      label={itemInput.Description}
                                      onBlur={(e) =>
                                        GetFindPostalCode(
                                          e.target.value,
                                          `${itemInput.Id}`,
                                          itemInput.GroupName
                                        )
                                      }
                                      onKeyDown={(e) =>
                                        GetFindPostalCode(
                                          e.target.value,
                                          `${itemInput.Id}`,
                                          itemInput.GroupName
                                        )
                                      }
                                      InputProps={{
                                        inputProps: {
                                          maxLength: 5,
                                          style: { textTransform: "uppercase" },
                                          outline: "none",
                                          autoComplete: "new-password",
                                          form: {
                                            autoComplete: "off",
                                          },
                                        },
                                      }}
                                    />
                                  ) : (
                                    <InputField
                                      inputType="text"
                                      control={control}
                                      regexGeneric={itemInput.RegularExpression}
                                      register={register}
                                      name={`${itemInput.Id}`}
                                      label={itemInput.Description}
                                      validations={{
                                        required: itemInput.Required,
                                      }}
                                      required={itemInput.Required}
                                      defaultValue={itemInput.Value}
                                      error={
                                        !!formState.errors[`${itemInput.Id}`]
                                      }
                                      helperText={
                                        formState.errors[`${itemInput.Id}`]
                                          ?.message
                                      }
                                      onBlur={(e) =>
                                        changeNameInputs(
                                          itemInput,
                                          e.target.value
                                        )
                                      }
                                      placeholder={itemInput.Description}
                                      // onKeyDown={(e) => UpdateCtrlQuestions(itemInput, e.target.value)}
                                    />
                                  )
                                }
                              />
                            );
                        }
                      })}
                    </AccordionDetails>
                  </Accordion>
                )
              )}
          </GenericContainerForm>
        ) : null}
        <Buttons
          onClickConfirm={handleSubmit((e) => {
            // console.log('SENDED', e)
            let workflowId = file.items?.WorkFlow?.Id || 0;
            let workflowName = file.items?.WorkFlow?.Name || 0;

            if (validacionBancoDatos() === false) {
              return null;
            } else if (
              workflowId === 8 ||
              (workflowId === 12 &&
                workflowName === "Contratación PROVIDA SPEN")
            ) {
              const values = getValues();
              //si la respuesta de sindicato es "SI"
              if (
                (values["5357"] && values["5357"] === "SI") ||
                (values["6176"] && values["6176"] === "SI")
              ) {
                //si no esta seleccionado sindicato no avanzar
                if (
                  (values["6176"] && !values["6179"]) ||
                  (values["5357"] && !values["5360"])
                ) {
                  Alert({
                    icon: "error",
                    okbtntext: "Ok",
                    title: "Selecciona un sindicato",
                  });
                  return;
                }
                //si esta seleccionado sindicato, abrir modal de confirmacion
                AlertConfirm(
                  {
                    icon: "info",
                    okbtntext: "Si",
                    notbtntext: "No",
                    title: "Confirma sindicato",
                    html: (
                      <Typography textAlign="center" variant="body1">
                        Por favor confirmar si su selección de sindicato{" "}
                        <b>{values["6179"] || values["5360"]}</b> es la
                        correcta:
                      </Typography>
                    ),
                  },
                  (event) => {
                    if (event.isConfirmed) {
                      SubmitForm(e);
                      setInitLoad(true);
                    }
                  }
                );
                return;
              } else if (
                (values["5357"] && values["5357"] === "NO") ||
                (values["6176"] && values["6176"] === "NO")
              ) {
                //if (!values["5359"]) return
                AlertConfirm(
                  {
                    icon: "info",
                    okbtntext: "Si",
                    notbtntext: "No",
                    title: "Confirmación",
                    html: (
                      <Typography textAlign="center" variant="body1">
                        ¿Confirma que NO desea la extensión de Beneficios
                        derivado de los instrumentos colectivos vigentes en AFP
                        Provida?
                      </Typography>
                    ),
                  },
                  (event) => {
                    if (event.isConfirmed) {
                      SubmitForm(e);
                      setInitLoad(true);
                    }
                  }
                );
                return;
              }
              SubmitForm(e);
              setInitLoad(true);
            } else {
              SubmitForm(e);
              setInitLoad(true);
            }
          })}
          marginBottom={IsDevice().IsIOS ? 85 : 75}
        />
      </FormProvider>
    </GenericContainer>
  );
}
